import { tr as __tr, useLocale as __useLocale } from "../../i18n/runtime";
import React from 'react';
import CatalogSearchForm from './CatalogSearchForm';
export default function HotelBookingForm() {
  __useLocale();
  return <CatalogSearchForm kind="hotel" />;
}
